import { useTranslations } from 'next-intl'
import styles from './LangSelectorModal.module.css'
import IconCross from '@/assets/img/Icon_Cross.svg'
import { Locale } from '@/i18n/constants'
import OptionLang from '@/components/UI/LanguageSelector/OptionLang'
import { LangSelectorKinds, LangSelectorSizes } from '@/components/UI/LanguageSelector/langSelectorTypes'

interface LangSelectorModalProps extends React.HTMLAttributes<HTMLDivElement> {
  selectedLocale: Locale
  localeList: Locale[]
  parentKind: LangSelectorKinds
  parentSize: LangSelectorSizes
  onLocaleSelect: (value: Locale) => void
  onClose: () => void
}

export default function LangSelectorModal ({ selectedLocale, localeList, parentKind, parentSize, onLocaleSelect, onClose }: LangSelectorModalProps) {
  const t = useTranslations('Modals.LangSelector')

  /**
   * Handles locale selection inside the modal
   * 
   * @param nextLocale - The unique identifier of the selected locale
   */
  function handleChangeLocale (nextLocale: Locale) {
    onLocaleSelect(nextLocale)
    onClose()
  }

  return (
    <div className={styles.modalWrapper}>
      <div className={styles.closeBtnWrapper}>
        <IconCross className={styles.closeBtn} onClick={onClose} />
      </div>

      <div className={styles.contentWrapper}>
        <h2 className={`title3`}>{t('content')}</h2>

        <div className={styles.langListWrapper}>
          <div className={styles.langList}>
            {localeList.map((el) => {
              return (
                <OptionLang
                  key={el}
                  locale={el}
                  selected={el === selectedLocale}
                  parentKind={parentKind}
                  parentSize={parentSize}
                  setLocale={handleChangeLocale}
                />
              )
            })
            }
          </div>
        </div>
      </div>
    </div>
  )
}